<template>
	<div class="modal" tabindex="-1" role="dialog" id="muven-channel-entity-list-synchronization-modal">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">
						<p class="mb-0">Forçar sincronização de entidades</p>
						<small class="text-muted">Canal: {{ channel.name }}</small>
					</h5>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<div class="muven-tip tip-info">
							<fa icon="info" class="tip-icon" />
							<p>Marque apenas as entidades que deseja forçar a sincronização no canal. Uma vez iniciada,
								você pode acompanhar o andamento pela tela de "Fila de Processamento".</p>
							<br>
							<p><b>OBSERVAÇÃO:</b> Como medida de segurança, a execução desta ação está limitada a apenas
								algumas poucas vezes por dia.</p>
						</div>
					</div>

					<div class="entity-check-container">
						<div class="entity-check" v-for="(en, index) in entityList" :key="index">
							<SwitchToggle class="mt-1 mb-1" :prop-check="en.checked" :label-checked="en.description"
								:label-unchecked="en.description" @updated="entityActivityHandler(en, !en.checked)" />
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary" @click="submit(channel, entityList)"
						:disabled="!hasAnyEntityChecked || loading">
						Forçar sincronização

						<Loading v-show="loading" />
					</button>

					<button type="button" class="btn btn-outline-secondary" @click="close()">Fechar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { EntityEnum } from '@c2b/muven-commons'
import ModalService from '../../utils/services/ModalService'
import ChannelService from '../services/ChannelService'
import { ChannelModel } from '../models/ChannelModel'
import { cloneDeep } from 'lodash'

const ID_MODAL = '#muven-channel-entity-list-synchronization-modal'

export default {
	name: 'ChannelEntityListSynchronizationCmp',
	data() {
		return {
			loading: false,
			channel: new ChannelModel(),
			entityList: [],
			// entityList: [
			// 	{
			// 		enum: EntityEnum.Product,
			// 		description: 'Produto',
			// 		checked: false,
			// 	},
			// 	{
			// 		enum: EntityEnum.ProductStore,
			// 		description: 'Preço e estoque',
			// 		checked: false,
			// 	},
			// 	{
			// 		enum: EntityEnum.Category,
			// 		description: 'Categoria',
			// 		checked: false,
			// 	},
			// 	{
			// 		enum: EntityEnum.Brand,
			// 		description: 'Marca',
			// 		checked: false,
			// 	},
			// 	{
			// 		enum: EntityEnum.ProductImage,
			// 		description: 'Imagem',
			// 		checked: false,
			// 	},
			// 	// {
			// 	// 	enum: EntityEnum.ProductCategory,
			// 	// 	description: 'Vínculo produto x categoria',
			// 	// 	checked: false,
			// 	// },
			// ],
		}
	},
	methods: {
		show(channel) {
			this.channel = cloneDeep(channel)
			this.mountEntityList()
			ModalService.show(ID_MODAL)
		},

		mountEntityList() {
			this.entityList = [];

			const isAllowedToExportAll = this.channel.isAllowExportAll();
			const isAllowedToExportProduct = isAllowedToExportAll
				|| this.channel.isAllowExportInsertProductAndUpdateStockAndPrice()
				|| this.channel.isAllowExportInsertProductAndUpdateStock();

			if (isAllowedToExportProduct) {
				this.entityList.push({
					enum: EntityEnum.Product,
					description: 'Produto',
					checked: false,
				});
			}

			this.entityList.push({
				enum: EntityEnum.ProductStore,
				description: 'Preço e estoque',
				checked: false,
			});

			if (isAllowedToExportAll) {
				this.entityList.push({
					enum: EntityEnum.Category,
					description: 'Categoria',
					checked: false,
				});

				this.entityList.push({
					enum: EntityEnum.Brand,
					description: 'Marca',
					checked: false,
				});

				this.entityList.push({
					enum: EntityEnum.ProductImage,
					description: 'Imagem',
					checked: false,
				});
			}
		},


		close() {
			ModalService.hide(ID_MODAL)
		},
		async submit(channel, entityList) {
			this.loading = true

			try {
				const entityListNormalized = entityList.filter((en) => {
					return en.checked
				}).map((en) => {
					return en.enum
				})

				await ChannelService.syncEntityList(channel.id, entityListNormalized)
				const entityListStringified = entityList.filter((en) => en.checked).map((en) => en.description).join(', ').replace(/,([^,]*)$/, ' e $1')
				this.$floatingAlert.info({
					message: `Solicitação de sincronização das entidades <b>${entityListStringified}</b> no canal <b>${channel.name}</b> registrado com sucesso.`,
					timeVisible: 10000,
				})
				this.$emit('syncRequestedSuccess')
				this.close()
			} catch (err) {
				this.$floatingAlert.error({
					title: '',
					message: err.message,
				})
			}

			this.loading = false
		},
		entityActivityHandler(entity, info) {
			entity.checked = info
		},
	},
	computed: {
		hasAnyEntityChecked() {
			return !!this.entityList.filter((en) => en.checked).length
		},
	},
}
</script>

<style lang="scss" scoped>
.entity-check-container {
	border: 1px solid var(--border);

	.entity-check {
		padding: 8px;

		&:nth-of-type(2n+1) {
			background-color: color-mix(in srgb, var(--text-strong) 5%, transparent);
		}
	}
}
</style>